import { useEffect } from "react";

/**
 * Premium smooth-scroll med Lenis (~8 KB).
 * — Skippas helt på touch/coarse-pointer (mobil/tablet) där momentum-scroll redan är inbyggt.
 * — Skippas vid prefers-reduced-motion.
 * — Importeras lazy så Lenis aldrig hamnar i mobile-bundlen.
 */
export function SmoothScroll() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    // Bara desktop med fin pekare (mus/trackpad) — mobil/touch får native scroll.
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

    let cancelled = false;
    let cleanup: (() => void) | null = null;

    import("lenis").then(({ default: Lenis }) => {
      if (cancelled) return;
      const lenis = new Lenis({
        duration: 1.1,
        easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });
      (window as unknown as { __lenis?: unknown }).__lenis = lenis;

      let rafId = 0;
      function raf(time: number) {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      }
      rafId = requestAnimationFrame(raf);

      cleanup = () => {
        cancelAnimationFrame(rafId);
        lenis.destroy();
        if ((window as unknown as { __lenis?: unknown }).__lenis === lenis) {
          delete (window as unknown as { __lenis?: unknown }).__lenis;
        }
      };
    });

    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, []);

  return null;
}
